import { TweenMax, TimelineMax } from 'gsap';
import css from './index.module.scss';
import { YouTubeVideoPlayer } from '@/components/ProductDetailComponents';
import { useGlobal } from '@/utils/useGlobal';

export default function TextA() {
    const { useLang, isMobile, useState, useEffect } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const [floatVideo, setFloatVideo] = useState(false);

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        if (!isMobile) {
            const scene1 = new ScrollMagic.Scene({
                triggerElement: '.dg200TextA',
                offset: 100,
                triggerHook: 1,
                duration: 200,
            });
            const timeline = new TimelineMax();
            const tween1 = TweenMax.fromTo(
                '.dg200TextA_pc .text',
                0.5,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                },
            );
            const tween2 = TweenMax.fromTo(
                '.dg200TextA_pc .watchVideo',
                0.5,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                },
            );
            timeline.add(tween1).add(tween2);
            scene1.setTween(timeline);
            controller.addScene(scene1);
        }
    }, []);

    return (
        <div className={`dg200TextA ${css.dg200TextA} ${isMobile ? 'dg200TextA_h5' : 'dg200TextA_pc'}`}>
            <p className="text">{t('dg200.textA')}</p>
            {!isMobile && <YouTubeVideoPlayer floatVideo={floatVideo} setFloatVideo={setFloatVideo} videoSrc="https://www.youtube.com/embed/ozVzv0jo_BM" />}
        </div>
    );
}
